import { render, staticRenderFns } from "./questionTreeDetail.vue?vue&type=template&id=1863402f&scoped=true&"
import script from "./questionTreeDetail.vue?vue&type=script&lang=js&"
export * from "./questionTreeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863402f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1863402f')) {
      api.createRecord('1863402f', component.options)
    } else {
      api.reload('1863402f', component.options)
    }
    module.hot.accept("./questionTreeDetail.vue?vue&type=template&id=1863402f&scoped=true&", function () {
      api.rerender('1863402f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonAnswer/detail/questionTreeDetail.vue"
export default component.exports